// https://switcheroo.atlassian.com/ui/gates/f0c8695a-3334-4f50-99e2-cecd6570ea6d/key/atlassian_projects_-_native_integration
export const PROJECTS_NATIVE_INTEGRATION_WITH_JIRA = 'atlassian_projects_-_native_integration';

// Verified teams in for you experiment - exposure only fires when recommendedTeams query has results
export const VERIFIED_TEAMS_IN_FOR_YOU_EXPERIMENT = 'verified_teams_in_for_you';

// Teams recommendations for you experiment - exposure only fires when rovo teams recommendations are cached.
export const TEAMS_RECOMMENDATIONS_FOR_YOU_EXPERIMENT = 'recommended_teams_in_for_you_page';

// https://switcheroo.atlassian.com/ui/gates/5df9f216-7f3c-4f54-a2c7-67873439d0ac/key/jira-space-invite-teams-app
export const JIRA_SPACE_INVITE_TEAMS_APP = 'jira-space-invite-teams-app';

// UC ML Powered Relevancy Engine experiment - https://switcheroo.atlassian.com/ui/gates/a8938eb8-f50c-457e-b185-35ed81e19657/key/navx_uc_ml_powered_relevancy_engine
export const NAVX_UC_ML_POWERED_RELEVANCY_ENGINE = 'navx_uc_ml_powered_relevancy_engine';

// https://switcheroo.atlassian.com/ui/gates/3e115d0a-6675-4df8-8e1e-085edbf1cecf/key/rovo-onboarding-in-atlas-home
export const ROVO_ONBOARDING_IN_ATLAS_HOME_EXPERIMENT = 'rovo-onboarding-in-atlas-home';

// https://switcheroo.atlassian.com/ui/gates/73ac0d28-4145-4453-a140-608117641c58/key/rovo_home_input_intent_exp
export const ROVO_HOME_INPUT_INTENT_EXP = 'rovo_home_input_intent_exp';

// https://switcheroo.atlassian.com/ui/gates/76a37227-3b8b-403f-b094-02eeaba602c2/key/rovo_ui_refresh_in_atlas_search_page_exp
export const ROVO_UI_REFRESH_IN_ATLAS_SEARCH_PAGE_EXP = 'rovo_ui_refresh_in_atlas_search_page_exp';
export const ROVO_TOWNSQ_EMPTY_STATE_GET_PROJECT_DETAILS_SKILL =
	'rovo_townsq_empty_state_get_project_details_skill';

export const HOME_ONBOARDING_TO_ROVO_CHAT_AND_SEARCH = 'home_onboarding_to_rovo_chat_and_search';

export const TOWNSQUARE_FSJ_ROVO_BUTTON_NUDGE = 'townsquare_fsj_rovo_button_nudge';

//https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/townsquare_enable_discover_preview_panels_exp/setup
export const DISCOVER_PREVIEW_PANELS_EXPERIMENT = 'townsquare_enable_discover_preview_panels_exp';
// https://switcheroo.atlassian.com/ui/gates/53f71e1a-c572-4ef0-9b30-2a6ef7c9ef24/key/rovo_chat_non_mau_townsquare_cta
export const ROVO_CHAT_NON_MAU_TOWNSQUARE_CTA = 'rovo_chat_non_mau_townsquare_cta';

// https://switcheroo.atlassian.com/ui/gates/76eb3c7d-6a2d-4c81-b014-fd76a4f567bf/key/townsquare_enable_friday_greeting_summary
export const FRIDAY_GREETING_SUMMARY_EXPERIMENT = 'townsquare_enable_friday_greeting_summary';

// https://switcheroo.atlassian.com/ui/gates/3a164ac5-c960-42dc-9e1b-0617ec400141/key/townsquare_enable_rovo_home_appification_exp
export const TOWNSQUARE_ENABLE_ROVO_HOME_APPIFICATION_EXP =
	'townsquare_enable_rovo_home_appification_exp';

// https://switcheroo.atlassian.com/ui/gates/2982193c-5d9f-4f74-96f6-61a8c5528aff/key/simplifying_frequently_visited_on_fyp
export const SIMPLIFY_FREQUENTLY_VISITED_EXP = 'simplifying_frequently_visited_on_fyp';

// https://switcheroo.atlassian.com/ui/gates/9e688bcf-25ca-47f7-acbb-4176e7d40261/key/townsquare_enable_worked_on_nudge_exp
export const TOWNSQUARE_ENABLE_WORKED_ON_NUDGE_EXP = 'townsquare_enable_worked_on_nudge_exp';

/** @internal Used for testing the router's featureGating experiment support only */
export const ROUTER_TEST_EXPERIMENT = 'townsquare_router_test_experiment';

// https://switcheroo.atlassian.com/ui/gates/5ffdf699-274b-484b-bfa7-1bfa7cab84fb/key/townsquare_assigned_pr_chat_integration
export const TOWNSQUARE_ASSIGNED_PR_CHAT_INTEGRATION_EXP =
	'townsquare_assigned_pr_chat_integration';

// Make sure you add your experiment to the list of valid experiments
export const experiments = {
	ROUTER_TEST_EXPERIMENT,
	PROJECTS_NATIVE_INTEGRATION_WITH_JIRA,
	VERIFIED_TEAMS_IN_FOR_YOU_EXPERIMENT,
	TEAMS_RECOMMENDATIONS_FOR_YOU_EXPERIMENT,
	JIRA_SPACE_INVITE_TEAMS_APP,
	ROVO_HOME_INPUT_INTENT_EXP,
	ROVO_UI_REFRESH_IN_ATLAS_SEARCH_PAGE_EXP,
	ROVO_TOWNSQ_EMPTY_STATE_GET_PROJECT_DETAILS_SKILL,
	NAVX_UC_ML_POWERED_RELEVANCY_ENGINE,
	ROVO_ONBOARDING_IN_ATLAS_HOME_EXPERIMENT,
	HOME_ONBOARDING_TO_ROVO_CHAT_AND_SEARCH,
	TOWNSQUARE_FSJ_ROVO_BUTTON_NUDGE,
	DISCOVER_PREVIEW_PANELS_EXPERIMENT,
	ROVO_CHAT_NON_MAU_TOWNSQUARE_CTA,
	FRIDAY_GREETING_SUMMARY_EXPERIMENT,
	TOWNSQUARE_ENABLE_ROVO_HOME_APPIFICATION_EXP,
	SIMPLIFY_FREQUENTLY_VISITED_EXP,
	TOWNSQUARE_ENABLE_WORKED_ON_NUDGE_EXP,
	TOWNSQUARE_ASSIGNED_PR_CHAT_INTEGRATION_EXP,
} as const;

export type ExperimentKeys = keyof typeof experiments;
export type ExperimentNames = (typeof experiments)[ExperimentKeys];
